import { Box, type BoxProps } from '@chakra-ui/react';
import { FaceliftSquaresLoadingIndicator } from '@/components/Atoms/FaceliftSquaresLoadingIndicator.tsx';
import FaceliftText from '@/components/Atoms/FaceliftText';

type FaceliftDataLoaderProps = {
  title: string;
  description?: string;
} & BoxProps;

const FaceliftDataLoader = ({
  title,
  description,
  ...boxProps
}: FaceliftDataLoaderProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="300px"
      width="100%"
      gap={4}
      {...boxProps}
    >
      <FaceliftSquaresLoadingIndicator />
      <FaceliftText fontWeight="bold" fontSize="lg">{title}</FaceliftText>
      {description && (
        <FaceliftText fontSize="md" textAlign="center">
          {description}
        </FaceliftText>
      )}
    </Box>
  );
};

export default FaceliftDataLoader;

